import {
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES,
  ROUTING_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const AverageCSATQuery: CubeQuery = {
  name: 'AverageCSAT',
  query: {
    measures: [
      DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_AVERAGE,
      DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_COUNT,
      ROUTING_MEASURES.ROUTING_COUNT,
    ],
    filters: [
      {
        member:
          DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_ROUTED_IN,
        operator: 'equals',
        values: ['true'],
      },
    ],
  },
  queryName: DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_COUNT,
}
